import React, { useState } from 'react';
import { AppProvider, useApp } from './context/AppContext';

import './styles/variables.css';

import LoginGate         from './components/login/LoginGate';
import Navbar            from './components/layout/Navbar';
import Hero              from './components/sections/Hero';
import Ticker            from './components/sections/Ticker';
import Services          from './components/sections/Services';
import Shop               from './components/shop/Shop';
import CartDrawer         from './components/shop/CartDrawer';
import Pipeline           from './components/sections/Pipeline';
import { Formations, Immobilier } from './components/sections/Formations';
import PhotosEntreprise  from './components/sections/PhotosEntreprise';
import Contact           from './components/sections/Contact';
import Tarifs            from './components/sections/Tarifs';
import AdBanner          from './components/sections/AdBanner';
import Footer            from './components/layout/Footer';
import Toast             from './components/common/Toast';
import FirebaseStatus    from './components/common/FirebaseStatus';
import Chatbot           from './components/chatbot/Chatbot';
import FactureModal      from './components/modals/FactureModal';
import DevisModal        from './components/modals/DevisModal';
import FinancialModal    from './components/modals/FinancialModal';
import AdminPanel        from './components/modals/AdminPanel';
import DocumentsModal    from './components/modals/DocumentsModal';
import ArchivesModal     from './components/modals/ArchivesModal';
import EtudiantsModal    from './components/modals/EtudiantsModal';
import PersonnelModal    from './components/modals/PersonnelModal';
import { useVisitTracking } from './hooks/useVisitTracking';
import Digitalisation from './components/sections/Digitalisation';
import Equipe from './components/sections/Equipe';

console.log('Firebase ProjectID:', process.env.REACT_APP_FIREBASE_PROJECT_ID);

const TICKER = '★ KOTOSTECHNOLOGY ★ Excellence · Innovation · Performance ★ Full Stack · Data Science · Solaire · Forage · Immobilier ★ 🛒 KotosShop — Achetez nos applications en ligne ★ www.kotostechnology.com ★ innovation@kotostechnology.com ★ B.P. 207 GODOMEY/BÉNIN ★';

function KotosApp() {
  const { currentUser, isVisitorMode, trackVisite } = useApp();

  // Analytics anonymisées — 1 fois par session, jamais pour le staff connecté
  useVisitTracking(trackVisite);

  const [showFacture,    setShowFacture]    = useState(false);
  const [showDevis,      setShowDevis]      = useState(false);
  const [showFinancial,  setShowFinancial]  = useState(false);
  const [showAdmin,      setShowAdmin]      = useState(false);
  const [showDocs,       setShowDocs]       = useState(false);
  const [showArchives,   setShowArchives]   = useState(false);
  const [showEtudiants,  setShowEtudiants]  = useState(false);
  const [showPersonnel,  setShowPersonnel]  = useState(false);
  const [contactService, setContactService] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  // LoginGate s'ouvre uniquement quand l'employé clique "Espace Privé"
  const [showLogin,      setShowLogin]      = useState(false);
  


  // Fermer le login dès que l'utilisateur se connecte
  React.useEffect(() => {
    if (currentUser) setShowLogin(false);
  }, [currentUser]);

  return (
    <>
      {/* Login modal — visible seulement si demandé et pas encore connecté */}
      {showLogin && !currentUser && !isVisitorMode &&
        <LoginGate onClose={() => setShowLogin(false)} />}

      <div style={{ paddingTop: isVisitorMode ? 44 : 0 }}>
        <Navbar
          onOpenLogin     ={() => setShowLogin(true)}
          onOpenFacture   ={() => setShowFacture(true)}
          onOpenDevis     ={() => setShowDevis(true)}
          onOpenFinancial ={() => setShowFinancial(true)}
          onOpenAdmin     ={() => setShowAdmin(true)}
          onOpenDocs      ={() => setShowDocs(true)}
          onOpenArchives  ={() => setShowArchives(true)}
          onOpenEtudiants ={() => setShowEtudiants(true)}
          onOpenPersonnel ={() => setShowPersonnel(true)}
          onContactService={(service, message) => {
            setContactService(service);
            setContactMessage(message);
          }}
        />
        <main>
          <Hero onOpenFacture={() => setShowFacture(true)} />
          <Ticker text={TICKER} />
          <AdBanner />
          <Services />
          <Digitalisation onDevis={(info) => setShowDevis(true)} />
          <Shop />
          <Pipeline />
          <PhotosEntreprise />
          <Immobilier />
          <Formations />
          <Tarifs />
          < Contact
            prefilledService={contactService}
            prefilledMessage={contactMessage}
          />
          <Equipe />
        </main>
        <Footer />
        <Chatbot />
        <Toast />
        <FirebaseStatus />
        <CartDrawer />
        {!isVisitorMode && showFacture    && <FactureModal    onClose={() => setShowFacture(false)}    />}
        {!isVisitorMode && showDevis      && <DevisModal      onClose={() => setShowDevis(false)}      />}
        {!isVisitorMode && showFinancial  && <FinancialModal  onClose={() => setShowFinancial(false)}  />}
        {!isVisitorMode && showAdmin      && <AdminPanel      onClose={() => setShowAdmin(false)}      />}
        {!isVisitorMode && showDocs       && <DocumentsModal  onClose={() => setShowDocs(false)}       />}
        {!isVisitorMode && showArchives   && <ArchivesModal   onClose={() => setShowArchives(false)}   />}
        {!isVisitorMode && showEtudiants  && <EtudiantsModal  onClose={() => setShowEtudiants(false)}  />}
        {!isVisitorMode && showPersonnel  && <PersonnelModal  onClose={() => setShowPersonnel(false)}  />}
      </div>
    </>
  );
}

export default function App() {
  return <AppProvider><KotosApp /></AppProvider>;
}
